// REST client for the OpenAI Compliance Logs Platform integrations.
import { idForPath, restDelete, restGet, restPatch, restPost } from "./restClient.js";

const ROOT = "/v1/openai-integrations";

export function listOpenAiIntegrations({ signal } = {}) {
    return restGet(ROOT, null, { signal });
}

export function createOpenAiIntegration({ apiKey, principalId }) {
    return restPost(ROOT, { api_key: apiKey, principal_id: principalId });
}

export function replaceOpenAiKey(integrationId, apiKey) {
    return restPatch(`${ROOT}/${idForPath(integrationId)}`, { api_key: apiKey });
}

export function deleteOpenAiIntegration(integrationId) {
    return restDelete(`${ROOT}/${idForPath(integrationId)}`);
}
